'use client';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { VariantProps } from 'tailwind-variants';

import CopyIcon from '@/fo/icons/base/icons/copy.svg';
import DoneIcon from '@/fo/icons/base/icons/done.svg';
import { UiKitLabelBase } from '@/fo/ui/kit/label/base';

import { styles } from './UiKitTextCopy.styles';

type Variants = VariantProps<typeof styles>;

export interface UiKitTextCopyProps {
  className?: string;
  classNameText?: string;
  text: string;
  view?: Variants['view'];
}

export function UiKitTextCopy({
  className,
  classNameText,
  text,
  view = 'default'
}: UiKitTextCopyProps) {
  const slots = styles({ view });
  const [isCopied, setIsCopied] = useState(false);
  const t = useTranslations();

  const onCopyText = () => {
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
    });
  };

  return (
    <button
      type="button"
      onClick={onCopyText}
      className={slots.base({ className })}
    >
      <span className={slots.text({ className: classNameText })}>{text}</span>

      {view === 'default' && <CopyIcon className={slots.icon()} />}
      {view === 'default' && isCopied && (
        <UiKitLabelBase color="canceled">{t('Copied')}</UiKitLabelBase>
      )}

      {view === 'compact' && !isCopied && <CopyIcon className={slots.icon()} />}
      {view === 'compact' && isCopied && <DoneIcon className={slots.icon()} />}
    </button>
  );
}
